import {Message, Menu, Grid, Input, Button, Divider, Avatar, Form, Card, Empty} from '@arco-design/web-react';
import styles from "./index.module.less"
import {Author, SelfAvatar,CommentList,Article,Content,QrCard} from "../../components";
import {userSelf,post} from "../../store";
import { observer } from "mobx-react-lite"
import {useEffect, useState} from "react"
import {getQuery, isHiddenPostStatus} from '../../utils'
import { trackView, getInboundChannelFromURL, withInboundChannel } from '../../utils/tracker'
import * as request from '../../utils/request'
import {Comments} from "../../store/comments";
import {QRCodeCanvas} from 'qrcode.react';
import {Helmet} from "react-helmet";

const Row = Grid.Row;
const Col = Grid.Col;

export default observer(function (){
    const [postData,setPostData]=useState({})
    const [notFound,setNotFound]=useState(false)
    const [commentStore]=useState(new Comments())
    const [comment,setComment]=useState()
    const [isSubmitting,setIsSubmitting]=useState(false)
    const query=getQuery()
    const postId=query.id
    const commentsQuery={post:postData._id}
    useEffect(()=>{
        // 切换 postId 时重置旧详情并丢弃过期响应：否则 A 的内容/二维码会一直
        // 渲染到 B 的请求返回，B 失败时还会停留在 A 的内容上
        let cancelled=false
        setNotFound(false)
        setPostData({})
        post.getPost({_id:postId})
            .then(result=>{
                if(cancelled) return
                // 详情拿不到（含 status=3 待审隐藏内容后端直接 404）时给明确空态，
                // 不能渲染空壳详情页 + 分享二维码
                if(!result){
                    setNotFound(true)
                    return
                }
                setPostData(result)
                // post.viewPost(postId)
                // v5 数据看板埋点：详情页 detail 上报；
                // inboundChannel 由 URL ?from 决定（外部分享链接带过来）。
                // 延后到拿到状态之后再上报：被隐藏（下架/不通过/待审隐藏）的内容
                // 整页拦截不算一次有效浏览，避免污染看板 detail 数据
                if(!isHiddenPostStatus(result.status)){
                    trackView(postId, 'detail', getInboundChannelFromURL())
                }
            })
        return ()=>{cancelled=true}
    },[postId])
    const {user:{wechat}={}}=postData
    const handleCommentChange=(value)=>{
        setComment(value)
    }
    const handleSubmitComment=async ()=>{
        if(!comment) return Message.info('请先填写评论内容！')
        if(isSubmitting) return
        setIsSubmitting(true)
        try {
            const result=await request.post('/api/comment/create',{
                user:userSelf.id,
                content:comment,
                post:postData._id,
            })
            if(result){
                await commentStore.loadmore(commentsQuery,true)
                setComment('')
                Message.success('发表成功！')
            }
        }finally {
            setIsSubmitting(false)
        }
    }
    // 审核不通过(-3)/被举报下架(-1)/待人工审核隐藏(3) 的内容在 Web 端一律不可见（包括作者自己）：
    // 详情页右侧有分享二维码、地址栏链接可直接复制，被处理内容一旦在这里可达，
    // 就能绕过列表隐藏继续向微信等渠道扩散，所以整页拦截（自见 limiting 不拦）；
    // 详情拿不到（404/已删除/status=3）同样给空态，不渲染空壳详情
    if(notFound||(postData&&isHiddenPostStatus(postData.status))){
        return (
            <Content className={styles.postPage}>
                <Empty
                    style={{marginTop:80}}
                    description={notFound?'内容不存在或已被处理，去看看别的内容吧～':'由于该内容已被下线处理，目前不可查看～'}/>
            </Content>
        )
    }
    return (
        <Content className={styles.postPage}>
            <Helmet>
                <meta property="og:title" content={postData.title} />
                <meta property="og:description" content={postData.content} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:image"
                    content="https://source.unsplash.com/random/1000x500"
                />
            </Helmet>
            <Row gutter={24}>
                <Col span={18}>
                    <div className={styles.post}>
                        <Article key={postData._id} item={postData} />
                        <div className={styles.commentWrap}>
                            <div className={styles.inputWrap}>
                                <SelfAvatar style={{marginRight:'20px'}} size={30}/>
                                <Input.TextArea
                                    value={comment}
                                    maxLength={300}
                                    showWordLimit
                                    onChange={handleCommentChange}
                                    placeholder='发表评论.' />
                            </div>
                            <div className={'arco-form-extra'} style={{paddingLeft:50}}>内容发布者观点及评论仅供其表达个人看法或观点，并不表明美刊立场。</div>

                            <div className={styles.btnWrap}>
                                <Button disabled={isSubmitting} onClick={handleSubmitComment} type={'primary'}>发表评论</Button>
                            </div>
                        </div>
                        {
                            postData._id&&(
                                <CommentList
                                    key={'comments'+postData._id}
                                    store={commentStore}
                                    query={commentsQuery}  />
                            )
                        }
                    </div>
                </Col>
                <Col span={6}>
                    <Card title='关于作者' bordered={false} className={styles.about_writer} >
                        <Author size={'middle'} user={postData.user} followed={postData.followed}/>
                    </Card>

                    <Card title='扫码分享给朋友' bordered={false} className={styles.share}>
                        <div className={styles.qr}>
                            {/* 二维码分享链接打渠道标签：扫码进来视为 from=qrcode，便于看板归因 */}
                            <QRCodeCanvas value={withInboundChannel(window.location.href, 'qrcode')}/>
                        </div>
                    </Card>

                </Col>
            </Row>
        </Content>
    )
})
